import { cognitoAxiosInstance } from 'config/axiosInstance'
import convertKeys from 'utils/convert-keys'
import { getToken } from 'services/amplify/auth'
import {
  DATA_FOOTPRINT_DATA_BUYERS,
  DATA_FOOTPRINT_DATA_SELLERS,
  DATA_FOOTPRINT_DATA_BREACHES,
} from 'resources/endpoints'

const fetchDataBuyers = async () => {
  const token = await getToken()
  const response = await cognitoAxiosInstance(token).get(DATA_FOOTPRINT_DATA_BUYERS)
  return convertKeys.toCamel(response.data)
}

const fetchDataSellers = async () => {
  const token = await getToken()
  const response = await cognitoAxiosInstance(token).get(DATA_FOOTPRINT_DATA_SELLERS)
  return convertKeys.toCamel(response.data)
}

const fetchDataBreaches = async () => {
  const token = await getToken()
  const response = await cognitoAxiosInstance(token).get(DATA_FOOTPRINT_DATA_BREACHES)
  return convertKeys.toCamel(response.data)
}

export default {
  fetchDataBuyers,
  fetchDataSellers,
  fetchDataBreaches,
}
